import React from "react";
import { useParams } from "react-router-dom";

const FacultyDetails = () => {
  const { id } = useParams(); // Get ID from URL

  return (
    <div className="faculty-section">
      <h2>Faculty Details</h2>
      <p>Faculty ID: {id}</p>
    </div>
  );
};

export default FacultyDetails;
